<template>
  <div id="container">
    <div class="face-to-face">
      <div class="title-img">
        <img src="~assets/images/redpkg1.png" />
      </div>
      <div class="context">
        <img src="~assets/images/redpkg2.png" />
        <div class="text-module">
          <div id="qrCode">
            <canvas></canvas>
          </div>
          <p>邀请好友扫码下载</p>
          <p>扫码步骤</p>
          <p>打开“微信”或“QQ”，点击右上角“+”</p>
          <p>
            使用
            <span>“扫一扫”</span>扫描上方二维码
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/../config";
import QRCode from "qrcode";
export default {
  data() {
    return {
      codeimg: ""
    };
  },
  mounted() {
    let that = this;
    var params = {};

    window["getInvitationCode"] = (invitationId, pkg, source, uuid) => {
      params["code"] = invitationId;
      params["pkg"] = pkg;
      params["source"] = source;
      params["uuid"] = uuid;
      window.getInvitation(params);
    };

    window["getInvitation"] = data => {
      var origin = window.location.origin;
      let canvas = document.querySelector("#qrCode canvas");
      // if (data["pkg"]) {
      //   let val =
      //     config.API_HOST +
      //     "/game-detail-pkg.html?pkg=" +
      //     data["pkg"] +
      //     "&source=" +
      //     data["source"] +
      //     "&uuid=" +
      //     data["uuid"] +
      //     "&code=" +
      //     data["code"];
      //   QRCode.toCanvas(canvas, val, function(error) {
      //     if (error) console.error(error);
      //   });
      // } else {
      //   QRCode.toCanvas(
      //     canvas,
      //     origin + "/v1/split/reference?code=" + data["abcd"],
      //     { margin: 0 },
      //     function(error) {
      //       if (error) console.error(error);
      //     }
      //   );
      // }
       QRCode.toCanvas(
          canvas,
          origin + "/v1/split/reference?code=" + data["abcd"],
          { margin: 0 },
          function(error) {
            if (error) console.error(error);
          }
        );
    };
  }
};
</script>
<style lang="less" scoped>
#container {
  width: 100%;
  background: url("~assets/images/face.png") no-repeat;
  background-size: cover;
  height: 100%;
  .face-to-face {
    text-align: center;
    padding-top: 0.49rem;
    .title-img > img {
      width: 2.96rem;
      height: 1.06rem;
    }
    .context {
      position: relative;
      margin-top: 0.19rem;
      height: 4.15rem;
      > img {
        width: 3.08rem;
        height: 4.12rem;
      }
      .text-module {
        position: absolute;
        top: 0.45rem;
        left: 50%;
        margin-left: -1.25rem;
        width: 2.5rem;
        #qrCode {
          width: 1.92rem;
          height: 1.92rem;
          margin: 0 auto;
        }
        #qrCode > canvas {
          width: 1.92rem !important;
          height: 1.92rem !important;
        }
        > p:nth-of-type(1) {
          margin-top: 0.075rem;
          font-size: 0.1875rem;
          color: #666;
        }
        > p:nth-of-type(2) {
          margin-top: 0.243rem;
          font-size: 0.166rem;
          text-align: left;
          padding-left: 0.01875rem;
          color: #fff;
          line-height: 0.28rem;
        }
        > p:nth-of-type(3) {
          text-align: left;
          margin-top: 0.075rem;
          font-size: 0.15rem;
          padding-left: 0.01875rem;
          color: #fff;
          min-width: 0.02144rem;
          line-height: 0.208rem;
        }
        > p:nth-of-type(4) {
          text-align: left;
          font-size: 0.15rem;
          padding-left: 0.01875rem;
          color: #fff;
          min-width: 2.51rem;
          line-height: 0.24rem;
        }
      }
    }
  }
}
</style>